export default {
  serviceDetails: [],
}
